const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.25
}

const intersectionHandler = (entries, observer) => {
    entries.forEach(entry => {
        if(entry.isIntersecting) {
            const el = entry.target
            const src = (() => {
                if (window.matchMedia('screen and (min-width: 1440px)').matches) {
                    return el.dataset.srcXl || el.dataset.src
                } else if (window.matchMedia('screen and (min-width: 1024px)').matches) {
                    return el.dataset.srcLg || el.dataset.srcXl || el.dataset.src
                } else if (window.matchMedia('screen and (min-width: 768px)').matches) {
                    return el.dataset.srcMd || el.dataset.srcLg || el.dataset.srcXl || el.dataset.src
                } else {
                    return el.dataset.srcSm || el.dataset.srcMd || el.dataset.srcLg || el.dataset.srcXl || el.dataset.src
                }
            })()
            
            if(el.tagName == 'IMG') {
                el.src = src
                el.onload = (ev) => {
                    el.style.filter = null
                }
            } else {
                let img = new Image()

                img.onload = (ev) => {
                    el.style.filter = null
                    el.style.backgroundImage = `url("${src}")`
                }

                img.src = src
            }

            observer.unobserve(entry.target)
        }
    })
}

let observer;

if (!('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    
    observer = {
        observe(el) {
            if(el.tagName == 'IMG') {
                el.src = el.dataset.src
            } else {
                el.style.backgroundImage = `url(${el.dataset.src})`
            }
        }
    }
} else {
    observer = new IntersectionObserver(intersectionHandler, options)
}

export default observer


// WEBPACK FOOTER //
// ../default-js/js/global/ImageIntersectionObserver.js